import React from "react";

//layoutpages
import Default from "../layouts/dashboard/default";

import { DefaultRouter } from "./default-router";
import { Layout1Router } from "./layout1-router";
import Maintenance from "../views/dashboard/extrapages/maintenance";

export const IndexRouters = [
  {
    path: "/",
    // element: <Maintenance />
    element: <Default />,
    children: [...DefaultRouter, ...Layout1Router],
  },
];
